import {
  useFeatureFlagValue,
  useFeatureFlagValueBool,
} from "@mirage/service-experimentation/useFeatureFlagValue";
import { useEffect, useState } from "react";
import { defaultCategoryConfig, getContentTypeFilterConfig } from "./config";

export function useCategoriesConfig() {
  const [config, setConfig] = useState(defaultCategoryConfig);

  const isMessagesEnabled =
    useFeatureFlagValue("dash_2025_03_03_search_message_results") === "ON";
  const multimediaFlag = useFeatureFlagValue(
    "dash_2025_03_13_multimedia_search",
  );

  const isMultimediaEnabled =
    multimediaFlag === "ON" || multimediaFlag === "V1";

  const isFilterSidebarEnabled = useFeatureFlagValueBool(
    "dash_2025_05_29_serp_filter_sidebar",
  );

  useEffect(() => {
    const config = isFilterSidebarEnabled
      ? getContentTypeFilterConfig()
      : defaultCategoryConfig;
    const updatedConfig = config.filter((category) => {
      if (category.id === "messages") {
        return isMessagesEnabled;
      }
      if (category.id === "image") {
        return isMultimediaEnabled;
      }
      return true;
    });
    setConfig(updatedConfig);
  }, [isFilterSidebarEnabled, isMessagesEnabled, isMultimediaEnabled]);

  return config;
}
